import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import Collapse from 'antd/es/collapse/Collapse';
import styled, { css } from 'styled-components';
import { ToolStatus as ToolStatusEnum } from '../../types/tool.types';
export const ToolCallContainer = styled(Collapse) `
  border-radius: ${({ theme }) => theme.border_radius.md};
  border: 1px solid;
  transition: all 0.3s ease;
  text-align: left;
  background-color: ${({ theme }) => theme.colors.white_1};
  margin-block: ${({ theme }) => theme.spacing.md}px;
  .ant-collapse-content {
    padding: 0 ${({ theme }) => theme.spacing.sm}px;
    background-color: transparent;
  }
  .ant-collapse-content > .ant-collapse-content-box:empty {
    display: none;
  }

  ${({ status }) => {
    switch (status) {
        case ToolStatusEnum.PENDING:
            return css `
          border-color: ${({ theme }) => theme.colors.white_1};
        `;
        case ToolStatusEnum.RUNNING:
            return css `
          border-color: ${({ theme }) => theme.colors.yellow_1};
        `;
        case ToolStatusEnum.SUCCESS:
            return css `
          border-color: ${({ theme }) => theme.colors.green_2};
        `;
        case ToolStatusEnum.FAILURE:
            return css `
          border-color: ${({ theme }) => theme.colors.error};
        `;
        case ToolStatusEnum.PARTIAL:
            return css `
          border-color: ${({ theme }) => theme.colors.orange_1};
        `;
        default:
            return css `
          border-color: ${({ theme }) => theme.colors.white_1};
        `;
    }
}}
`;
export const ToolCallInline = styled.div `
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.xs}px;
  padding: 0;
  margin-bottom: ${({ theme }) => theme.spacing.sm}px;
  font-size: ${({ theme }) => theme.fonts.body4};
  color: ${({ theme }) => theme.colors.grey_3};
  line-height: 1.4;
  cursor: ${({ $expandable }) => ($expandable ? 'pointer' : 'default')};
  user-select: ${({ $expandable }) => ($expandable ? 'none' : 'auto')};
`;
export const ToolHeader = styled.header `
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.sm}px;
`;
export const ToolInfo = styled.div `
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.xs}px;
`;
export const ToolName = styled.h4 `
  margin: 0;
  font-size: ${({ theme }) => theme.fonts.body3};
  font-weight: ${({ theme }) => theme.fontWeights.semibold};
  color: ${({ theme }) => theme.colors.grey_1};
`;
export const StyledToolStatus = styled.div `
  font-size: ${({ theme }) => theme.fonts.body4};
  color: ${({ theme }) => theme.colors.grey_2};
  margin-top: ${({ theme }) => theme.border_radius.xs};
`;
export const ToolContent = styled.div `
  margin-top: ${({ theme }) => theme.spacing.xs}px;
`;
export const CollapsibleSection = styled.div `
  .ant-collapse-header {
    padding: ${({ theme }) => theme.spacing.xs}px 0 !important;
    font-size: ${({ theme }) => theme.fonts.body4};
    color: ${({ theme }) => theme.colors.grey_2};
  }

  .ant-collapse-content-box {
    padding: ${({ theme }) => theme.spacing.sm}px 0 0 0 !important;
  }
`;
export const ToolArguments = styled.div `
  pre {
    margin: 0;
    padding: ${({ theme }) => theme.spacing.sm}px;
    background: ${({ theme }) => theme.colors.grey_5};
    border-radius: ${({ theme }) => theme.border_radius.sm};
    font-size: ${({ theme }) => theme.fonts.body4};
    overflow-x: auto;
    max-height: 300px;
    overflow-y: auto;
  }
`;
export const ToolResult = styled.div `
  pre {
    margin: 0;
    padding: ${({ theme }) => theme.spacing.sm}px;
    background: ${({ theme }) => theme.colors.grey_5};
    border-radius: ${({ theme }) => theme.border_radius.sm};
    font-size: ${({ theme }) => theme.fonts.body4};
    overflow-x: auto;
    max-height: 300px;
    overflow-y: auto;
  }
`;
export const ToolError = styled.div `
  color: ${({ theme }) => theme.colors.red_1};
  font-size: ${({ theme }) => theme.fonts.body4};
  padding: ${({ theme }) => theme.spacing.sm}px;
  background: ${({ theme }) => theme.colors.red_5};
  border-radius: ${({ theme }) => theme.border_radius.sm};
  border: 1px solid ${({ theme }) => theme.colors.red_4};
`;
export const ToolAnalyzeContainer = styled.div `
  padding: ${({ theme }) => theme.spacing.md}px;
  border-radius: ${({ theme }) => theme.border_radius.md};
  margin-bottom: ${({ theme }) => theme.spacing.sm}px;
  background-color: ${({ theme }) => theme.colors.beige_1};
  border: 1px solid ${({ theme }) => theme.colors.grey_4};
`;
export const ExecutionTime = styled.span `
  color: ${({ theme }) => theme.colors.grey_3};
  font-size: ${({ theme }) => theme.fonts.overline};
`;
export const GrantCard = styled.article `
  background: ${({ theme }) => theme.colors.white_1};
  border-radius: ${({ theme }) => theme.border_radius.sm};
  padding: ${({ theme }) => theme.spacing.sm}px;
  margin-bottom: ${({ theme }) => theme.spacing.sm}px;
  border: 1px solid ${({ theme }) => theme.colors.grey_5};
  transition: box-shadow 0.3s ease;

  &:hover {
    box-shadow: ${({ theme }) => theme.appearance.box_shadow_hover};
  }

  &:last-child {
    margin-bottom: 0;
  }
`;
export const GrantTitle = styled.h5 `
  margin: 0 0 ${({ theme }) => theme.spacing.sm}px 0;
  font-size: ${({ theme }) => theme.fonts.body3};
  font-weight: ${({ theme }) => theme.fontWeights.semibold};
  color: ${({ theme }) => theme.colors.grey_1};
`;
export const GrantRecommendation = styled.p `
  margin: 0 0 ${({ theme }) => theme.spacing.sm}px 0;
  font-size: ${({ theme }) => theme.fonts.body4};
  color: ${({ theme }) => theme.colors.grey_2};
  line-height: 1.5;

  strong {
    color: ${({ theme }) => theme.colors.grey_1};
  }
`;
export const GrantAction = styled.p `
  margin: 0;
  font-size: ${({ theme }) => theme.fonts.body4};
  color: ${({ theme }) => theme.colors.blue_1};
  line-height: 1.5;

  strong {
    color: ${({ theme }) => theme.colors.grey_1};
  }
`;
export const GrantTable = styled.table `
  width: 100%;
  border-collapse: collapse;
  margin-top: ${({ theme }) => theme.spacing.sm}px;
`;
export const GrantTableHeader = styled.tr `
  border-bottom: 2px solid ${({ theme }) => theme.colors.grey_4};
`;
export const GrantTableHeaderCell = styled.th `
  padding: ${({ theme }) => theme.spacing.sm}px;
  text-align: left;
  font-weight: ${({ theme }) => theme.fontWeights.semibold};
`;
export const GrantTableRow = styled.tr `
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey_4};
`;
export const GrantTableCell = styled.td `
  padding: ${({ theme }) => theme.spacing.sm}px;
`;
export const GrantTableTitleCell = styled(GrantTableCell) `
  font-weight: ${({ theme }) => theme.fontWeights.medium};
`;
export const StyledSuccessIcon = styled(CheckCircleOutlined) `
  color: ${({ theme }) => theme.colors.green_status};
`;
export const StyledErrorIcon = styled(CloseCircleOutlined) `
  color: ${({ theme }) => theme.colors.red_1};
`;
